export const continueWizardAfterLoginParam = 'continueWizard';
